export const COLOR_AZUL_MAIN = '#000D39';
export const COLOR_ROJO = '#DC3545';
export const COLOR_VERDE = '#1c8030';